@switch (status()) {
  @case (syncState.None) {
    <fa-icon [icon]="['fas', 'minus']"
             class="ms-3 text-secondary"></fa-icon>
  }
  @case (syncState.Started) {
    <fa-icon [icon]="['fas', 'spinner']"
             [animation]="'spin'"
             class="ms-3 text-primary"></fa-icon>
  }
  @case (syncState.Verify) {
    <fa-icon [icon]="['fas', 'check']"
             class="ms-3 text-primary"></fa-icon>
  }
  @case (syncState.Successful) {
    <fa-icon [icon]="['fas', 'check']"
             class="ms-3 text-success"></fa-icon>
  }
  @case (syncState.Timeout) {
    <fa-icon [icon]="['far', 'clock']"
             class="ms-3 text-secondary"></fa-icon>
  }
  @case (syncState.Failed) {
    <fa-icon [icon]="['fas', 'exclamation-triangle']"
             class="ms-3 text-warning"></fa-icon>
  }
  @case (syncState.Error) {
    <fa-icon [icon]="['fas', 'exclamation-triangle']"
             class="ms-3 text-danger"></fa-icon>
  }
}